var _defs, _style, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 87",
    width: 90,
    height: 87,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 90,
    height: 87,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABXCAMAAACz6KLuAAAAAXNSR0IB2cksfwAAAGxQTFRFMD6B////8vP35efvZG6hSlaRmJ7A2NvnPUqJV2KZsrbPfoawl5/AfYawsrfPV2KYy8/fpKvHi5K4ipK4pKrIsbfPLTt/NUOEGil0GShzLDp+FyZyvsLYHCt1lp2/Kjh9JDJ5JTR6IjF5fYewTqKtvQAAAiZJREFUeJzt2F1PwjAUBuC2OAIBFQnhQm/8+P+/SRKNiRiCBDXIXCdbNwXW0/O2CVGSctOb7ckSzznvqVIc7CePlj4En0c60pH+A1rmfrSS2vKG9UklUx+6LVfdT8hWKhXthk3TXb0SovcByqJpk3SyLo/mxxBy81GS7r0JzK5l0X8HadFfmvNsGSY7aHm6KM9Ovg6SXRUiW+atTqpDZHddV+8lmrJdsrsbN5VdnlR5O2Wm0c9fzXmS+cvcDBnMzTmce8vseKLLm5P5yTecmXM085SBodr6Mudg4ScDtLV1ABmJAkt5IzKUMiox5Z1kuYeMBdhe62AymI2jF3OWyQDKaOxulTcqw4n+Y2eojC8LVTKM5TMo47Qp77GS8gmTPVacIhnGqiV0NoVkn+1JqYuNLESmp4jstZhdSdOOSj4gj3t99aWZVMmjNRnC6aKeb4oJlUysyRBOm065TgsZWqpguu7BWz0pz/1kCKd/u3tlTYZwemtuYEsVTO9MJH7x8aD3Zl0jGcLpxhTlliqYtsznnWQIp62TH9rrOZrIFMRmaDKtgDuDm6ZzEChvJ+1KWP7OgNwK7JnCto6D5rYCrrxpmt833HcGmkY2GdedgaaxHclZ3gSNbl/UnYGm4b2OuDPQNC67WsdG190A7Uh0eVu/uvrrQDtSnQwgbWxMrlrH0jdEhWxsVC6T4e6+2ZFUXfcELFMP//9/IUY60pGO9PHRB/odJ/0NTCI+ZytSivgAAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Background",
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6d6aa00196a290c0cc13b9ee2df7ccde.svg";
export { ForwardRef as ReactComponent };